import { Component, EventEmitter, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { NotificationType, ThriveNotification } from 'src/app/core/models/notification.model';
import { AuthService } from 'src/app/core/services/auth.service';
import { NotificationService } from 'src/app/core/services/notification.service';
import { ToastrService } from 'ngx-toastr';
import { take } from 'rxjs/operators';
import { Router } from '@angular/router';
import { Observable } from 'rxjs';
@Component({
  selector: 'app-notification-component',
  templateUrl: './notification-component.component.html',
  styleUrls: ['./notification-component.component.scss']
})
export class NotificationComponentComponent implements OnInit, OnChanges {
  @Input()
  fixedToBottomRight = false;
  @Input()
  closeNotifications: boolean;

  numberOfNotifications = 0;
  notifications: any;

  showNotificaitons = false;
  constructor(private notificationService: NotificationService, private authService: AuthService, private toastr: ToastrService, private router: Router) {
    this.authService.currentUser.pipe(take(2)).subscribe(async user => {
      if (user) {
        this.notifications  =await this.notificationService.checkInstructorAccountNotifications(user.userId);
        this.numberOfNotifications = this.notifications.length;
      }
    });

  }

  async showNotifications() {
    this.showNotificaitons = !this.showNotificaitons;
    if (this.showNotificaitons) {
      this.notifications.forEach(notification => {
        const toast = this.toastr.warning(this.getNotificationBody(notification.type), this.getNotificationTitle(notification.type), {
          timeOut: 0,
          positionClass: 'toast-bottom-right',
          messageClass: notification.type,
          extendedTimeOut: 0
        });
        toast.onTap
          .pipe(take(1))
          .subscribe(data => this.toasterClickedHandler(toast));

      });
      await this.delay(200);
    } else {
      this.toastr.clear();
    }
  }

  toasterClickedHandler(data: any) {
    console.log('Toastr clicked ', data.toastRef.componentInstance.options.messageClass);
    const type = data.toastRef.componentInstance.options.messageClass;
    this.toastr.clear();
    if (type === NotificationType.NoBookingDates) {
      this.router.navigate(['/profile'],{ queryParams: { view: 'dates' }});
    } else if (type === NotificationType.NoHourlyRateSet) {
      this.router.navigate(['/profile'],{ queryParams: { view: 'rate' }});
    } else if (type === NotificationType.NoPersonalBio) {
      this.router.navigate(['/profile'],{ queryParams: { view: 'bio' }});
    } else if (type === NotificationType.NoProfilePicture) {
      this.router.navigate(['/profile'],{ queryParams: { view: 'pic' }});
    }
  }
  getNotificationBody(type: NotificationType): string {
    if (type === NotificationType.NoBookingDates) {
      return 'Please specify dates you are available.';
    } else if (type === NotificationType.NoHourlyRateSet) {
      return 'Please set the rate you charge per hour.'
    } else if (type === NotificationType.NoPersonalBio) {
      return 'Let your clients know who you are. '
    } else if (type === NotificationType.NoProfilePicture) {
      return 'Clients need to recognize you. Please upload a picture.'
    }
  }
  getNotificationTitle(type: NotificationType): string {
    if (type === NotificationType.NoBookingDates) {
      return 'Instructing Schedule Needed';
    } else if (type === NotificationType.NoHourlyRateSet) {
      return 'Get Paid';
    } else if (type === NotificationType.NoPersonalBio) {
      return 'About You';
    } else if (type === NotificationType.NoProfilePicture) {
      return 'Smile';
    }
  }
  delay(ms: number) {
    return new Promise(resolve => setTimeout(resolve, ms));
  }
  ngOnInit(): void {
  }
  ngOnChanges(changes: SimpleChanges): void {
    if (this.closeNotifications) {
      this.toastr.clear();
    }
  }
}
